<template>
  <div id="pbn-filters">
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
          <v-select
            v-if="this.f.clients && this.f.clients.length"
            v-model="filters['clients']"
            :options="this.f.clients.concat([{id: 'null', name: 'No Client'}])"
            label="name"
            index="id"
            multiple="multiple"
            @input="search"
            placeholder="Clients"
          >
          </v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select
          placeholder="Domain Supplier"
          v-model="filters['domainSupplier']"
          :options="['client', 'in-house']"
          @input="search"
        ></v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <label>Show completed:</label>
        <input type="checkbox" id="" v-model.number="filters['completed']" @change="search">
      </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="row col-lg-12 m-t-md">
        Showing <b>{{ meta.count }}</b> results
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { ORDERS_SET } from '../../../../store/mutation-types'
import { Query } from '../../../../mixins/helperMixin'

export default {
  data () {
    return {
      meta: {
        count: 0,
        resultCount: 0
      },
      filters: {},
      multiFilters: {},
      actionFilters: {}
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mixins: [Query],
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  methods: {
    search (e, type = null) {
      axios.get('/pbn/builds/orders?' + this.buildQuery(this.filters))
        .then(r => {
          this.$store.commit(ORDERS_SET, r.data.data)
          this.meta = r.data.meta
        }).catch(e => {
          this.$toastr.error(e, 'Whoopsy Daisy')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Orders/Filters.vue